import { Agent, type BootstrapOptions } from './agent'

let agent: Agent | null

export function bootstrap(options?: BootstrapOptions) {
  if (agent) {
    throw new Error(
      'The agent is already running, call dispose() to bootstrap()',
    )
  }

  if (!options || typeof options !== 'object') {
    throw new Error(
      'The provided "options" are invalid, expect an object to bootstrap()',
    )
  }

  if (!options.hasOwnProperty('enabled')) {
    throw new Error(
      'The provided "options#enabled" is invalid, expect a boolean to bootstrap()',
    )
  }

  if (!options.hasOwnProperty('baseUrl') || !options.baseUrl) {
    throw new Error(
      'The provided "options#baseUrl" is invalid, expect a string to bootstrap()',
    )
  }

  if (
    !options.hasOwnProperty('batchReportInterval') ||
    !options.batchReportInterval
  ) {
    throw new Error(
      'The provided "options#batchReportInterval" is invalid, expect a positive integer to bootstrap()',
    )
  }

  agent = new Agent(options)
}

export function observe(media: HTMLVideoElement | null, mediaId: string) {
  if (!agent) {
    throw new Error('The agent is not running, call bootstrap() to observe()')
  }

  if (!(media instanceof HTMLMediaElement)) {
    throw new Error(
      'The provided "media" is invalid, expect a HTMLMediaElement to observe()',
    )
  }

  if (!mediaId || typeof mediaId !== 'string') {
    throw new Error(
      'The provided "mediaId" are invalid, expect a string to observe()',
    )
  }

  agent.observe(media, mediaId)
}

export function dispose() {
  if (!agent) {
    return
  }

  agent.dispose()
  agent = null
}

export function updateMediaId(mediaId: string) {
  if (!agent) {
    return
  }
  agent.nextMediaId = mediaId
}

export const VERSION = '0.2.11'
